import { TerminalAssignmentPromptComponent } from '../../shared/components/terminal-assignment-prompt/terminal-assignment-prompt.component';
import { ModalService } from '../../lean-shared/components/nz-modal-service/modal.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { ModalOptionsConfig } from '../../lean-shared/components/nz-modal-service/modal.service';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class SystemPromptsService {
	runningModal: NzModalRef;
	constructor(public modal: ModalService) {}

	openTerminalAssignmentPrompt(selectedTerminal?) {
		return new Promise((resolve, reject) => {
			const config = this.createTerminalAssignmentPromptConfig(resolve, reject);
			config.nzComponentParams.data = selectedTerminal ? selectedTerminal : null;
			this.runningModal = this.modal.createModal(TerminalAssignmentPromptComponent, config);
		});
	}

	createTerminalAssignmentPromptConfig(resolve, reject) {
		const config = new ModalOptionsConfig();
		config.className = 'moniepoint-dialog';
		config.nzWidth = 496;
		config.nzComponentParams.callback = (result) => {
			this.terminalAssignmentPromptCallBack(result, resolve, reject);
			this.runningModal.destroy();
		};
		return config;
	}

	terminalAssignmentPromptCallBack(result, resolve, reject) {
		if (result) {
			resolve(result);
		} else {
			reject(result);
		}
		this.runningModal.destroy();
	}
}
